import { allModelsSelector, singleModelSelector } from 'common-src/utils/selectorUtils';

export const getPatientEncounter = (state, id) =>
  singleModelSelector(state, 'PatientEncounter', id);

export const getPatientEncounters = (state, patientId) =>
  allModelsSelector(state, 'PatientEncounter', (pmp) => pmp.patientId === patientId).sort(
    (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
  );
